import { jsx as e } from "react/jsx-runtime";
import { c as a } from "../clsx-OuTLNxxd.js";
import { c as l } from "../background-bUl5ds8G.js";
const u = "SectionContainer-module_section-container__bNmH8",
  C = "SectionContainer-module_background__K8Y7k",
  _ = "SectionContainer-module_spacing-top-regular__qG5N3",
  B = "SectionContainer-module_spacing-bottom-regular__Hi9Z4",
  S = "SectionContainer-module_spacing-top-compact__ZLxC7",
  b = "SectionContainer-module_spacing-bottom-compact__kuieD",
  k = "SectionContainer-module_spacing-top-condensed__OP7lD",
  T = "SectionContainer-module_spacing-bottom-condensed__1zm9Z",
  o = {
    sectionContainer: u,
    background: C,
    spacingTopRegular: _,
    spacingBottomRegular: B,
    spacingTopCompact: S,
    spacingBottomCompact: b,
    spacingTopCondensed: k,
    spacingBottomCondensed: T
  },
  N = _ref => {
    let {
      className: s,
      wrapperClassName: i,
      backgroundColor: c = "white",
      children: r,
      spacingTop: n = null,
      spacingBottom: t = null,
      dataContentName: p = null,
      id: m
    } = _ref;
    const d = c == "neutral05" ? "neutral01" : c,
      g = l(d);
    return /* @__PURE__ */e("div", {
      id: m,
      className: a(i, o.background, g),
      "data-content-name": p,
      children: /* @__PURE__ */e("div", {
        className: a(s, o.sectionContainer, {
          [o.spacingTopRegular]: n == "regular",
          [o.spacingBottomRegular]: t == "regular",
          [o.spacingTopCompact]: n == "compact",
          [o.spacingBottomCompact]: t == "compact",
          [o.spacingTopCondensed]: n == "condensed",
          [o.spacingBottomCondensed]: t == "condensed"
        }),
        children: r
      })
    });
  };
export { N as SectionContainer };